import { Button } from "@/components/mui";
import RpIcon from "@/components/RpIcon";
import { CARD_STRING_TYPE as CARD_TYPE, KYC_STATUS, MAX_WIDTH } from "@/constant/Constant";
import RouteConstant from "@/constant/RouteConstant";
import useSettings from "@/hook/useSettings";
import KYCDialog from "@/pages/user/components/KYCDialog";
import MobileDialog from "@/pages/user/components/MobileDialog";
import { getCardBinList } from "@/redux/slices/card";
import { dispatch } from "@/redux/store";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import {useRequest, useSize} from "ahooks";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _styles from "./index.module.less";
import mobileClasses from "./mobile.module.less";

import useMobileDetect from "next-device-detection";

import Cards from '@/components/Cards';
// import PageBack from "@/components/PageBack";
import { useConfirm } from "material-ui-confirm";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader";
import OpenOrDownloadApp from "@/components/OpenOrDownloadApp";
import useSonicMigrateIntercept from "@/hook/useSonicMigrateIntercept";

export default function CardApplication() {
  const {t} = useTranslation();
  const {settings} = useSettings();
  const [current, setCurrent] = useState(CARD_TYPE.VIRTUAL);
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();
  const detectMobile = useMobileDetect();
  const confirm = useConfirm();
  const { showAppStoreModal, setShowAppStoreModal, interceptAction } = useSonicMigrateIntercept();

  const {cardBinList, loading} = useSelector((state) => state.card);
  const {user} = useSelector((state) => state.user);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [kycOpen, setKycOpen] = useState(false);

  const [isScrolled, setIsScrolled] = useState(false);


  const styles = useMemo(() => {
    return mobileClasses;
    // if (detectMobile.isMobile) {
    //   return mobileClasses;
    // }
    // return _styles;
  }, [detectMobile.isMobile]);

  const _initData = async () => {
    dispatch(getCardBinList());
  };
  useEffect(() => {
    _initData();
  }, []);

  const getCardBinListRes = useRequest(async () => {
    const res = await getCardBinList();

    return res as any;
  }, { manual: true });

  const _applyCard = () => {
    interceptAction();
  };

  const _checkBeforeApply = () => {
    if (user.kycStatus !== KYC_STATUS.KYC_STATUS_APPROVED) {
      _guideToKYC();
      return false;
    }
    return true;
  }

  const _guideToKYC = () => {
    confirm({
      title: t('info'),
      description: t('need_mobile_bind_confirm') })
      .then(() => {
        navigate(RouteConstant.KYC_MAIN);
      })
      .catch(() => {
        /* ... */
      });
  }

  // const _renderSelectIcon = (type: CARD_TYPE) => {
  //   if (current === type) {
  //     return (
  //       <Box
  //         sx={(theme) => {
  //           return {
  //             borderColor: theme.palette.text.secondary,
  //           };
  //         }}
  //         className={styles["select-icon"]}
  //         style={{color: settings.theme === "light" ? "white" : "black"}}
  //       >
  //         <RpIcon icon="correct" size={28}/>
  //       </Box>
  //     );
  //   } else {
  //     return null;
  //   }
  // };

  const _handleRecords = () => {
    navigate(RouteConstant.CARD_APPLY_LIST);
  };

  const _checkMobile = () => {
    // 这里先用mobile判断  以后应与app统一  增加mobileStatus判断是否绑定手机
    const mobileBind = !!user.mobile;

    if (!mobileBind) {
      setMobileOpen(true);
    }
    return mobileBind;
  };
  const _checkKyc = () => {
    const kycApproved = user.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED;
    if (!kycApproved) {
      setKycOpen(true);
    }
    return kycApproved;
  };

  const _onMobileBindSuccess = () => {
    setMobileOpen(false);
    _checkKyc();
  };

  // const _cardImg = (cardType) => {
  //   if (cardType == CARD_TYPE.VIRTUAL) {
  //     return `/images/cards/virtual-card${
  //       settings.theme === "light" ? "-light" : ""
  //     }.png`;
  //   }
  //   return `/images/cards/physical-card${
  //     settings.theme === "light" ? "-light" : ""
  //   }.png`;
  // };

  const onCardChange = (card) => {
    if (!card) return;
    setSelected(card);
    setCurrent(card.cardType)
  }

  // if (!cardBinList?.length) {
  //   return <Typography>Empty Card Bin List</Typography>;
  // }

  const _renderSupportPays = (type: CARD_TYPE) => {
    return (
      <Stack direction="row" className={styles["support-pays"]}>
        {/* <Stack direction="row"
               sx={(theme) => ({
            border: `1px solid ${theme.palette.borderColor.one}`,
          })}
          className={styles["pay-item"]}
        >
          <img src={`/images/pay/visa-${settings.theme}.png`} height={'20'}/>
        </Stack>
        {type === CARD_TYPE.PHYSICAL && (
          <Stack direction="row"
                 sx={(theme) => ({
              border: `1px solid ${theme.palette.borderColor.one}`,
            })}
            className={styles["pay-item"]}
          >
            <img src={`/images/pay/atm-${settings.theme}.png`} height={'20'}/>
          </Stack>
        )} */}
        <Box
          
          className={`${styles["pay-item"]} ${styles.payVisa}`}
        >
          {/* <img src={`/images/pay/apple-${settings.theme}.png`} height={'20'}/> */}
        </Box>
        <Box
         
          className={`${styles["pay-item"]} ${styles.payGoogle}`}
        >
          {/* <img src={`/images/pay/apple-${settings.theme}.png`} height={'20'}/> */}
        </Box>
        <Box
         
          className={`${styles["pay-item"]} ${styles.payApple}`}
        >
          {/* <img src={`/images/pay/google-${settings.theme}.png`} height={'20'}/> */}
        </Box>
      </Stack>
    );
  };

  const size = useSize(document.querySelector('body'));
  const cardScale = useMemo(() => {
    let _width = size?.width
    if (_width > MAX_WIDTH) {
      _width = MAX_WIDTH
    }
    const scale  = _width / 375
    return scale
  }, [size])

  return (
    <Box
      sx={theme => {
        return {
          width: "100%",
          backgroundImage: 'url(/images/sonic/sonic-home-bg.png)',
          backgroundSize: '100%', // Ensures the image covers the entire box
          backgroundPositionY: '-10vh', // Centers the image
        }
      }}
      className={styles.wraper}>
      <SimpleHeader transparentBg={!isScrolled} title={t("card_application")} action={<Box onClick={_handleRecords}><RpIcon icon={"log"} size={22}></RpIcon></Box>}/>
      <Box
        sx={(theme) => {
          return {
            paddingTop:'16px',
            backgroundColor: "transparent"
              // detectMobile.isMobile
              // ? "transparent"
              // : theme.palette.background.paper,
          };
        }}
        className={styles["container"]}
      >
        <Typography
          sx={{ fontSize: '24px', fontWeight: 700, textAlign: 'center' }}
          className={styles.title}>
          {t("card_application")}
        </Typography>
        <Typography className={styles["sub-title"]}>
          {t("get_a_card")}
        </Typography>

        <Box
          sx={{
            // minHeight: '260px'
            height: 266 * cardScale + 'px', //theme.typography.pxToRem(), // '201px',
            maxHeight: 266 * (520 / 375) + 'px'
        }}
          className={styles.cardBlock}>
          {cardBinList && cardBinList.length > 0 && <Cards onChange={onCardChange} list={cardBinList} /> }
        </Box>
        {selected && <Box className={styles.info}>
          <Box sx={{backgroundColor:'#222324',padding:'16px',borderRadius:"8px",marginTop:"14px"}}>
            <Stack direction="row" justifyContent="space-between">
              <p className={'h4'}>
                {selected.cardType == CARD_TYPE.VIRTUAL
                  ? t("virtual_card")
                  : t("physical_card")}
              </p>
              <Typography>
                <span className={'color-error-dark h4'}>{selected.price}</span> <span className={'color-error-dark little'}>USD</span>
              </Typography>
            </Stack>
            <p className={'text-secondary'}>
              {selected.cardType == CARD_TYPE.VIRTUAL
                ? t("enjoy_seamless_spending")
                : t("spend_and_withdraw")}
            </p>
            {_renderSupportPays(selected.cardType)}
          </Box>
        </Box>}
        <Stack className={styles.btnWrap} direction="row" justifyContent="center">
          <Button
            className={styles.btn}
            variant="contained"
            size="medium"
            fullWidth
            onClick={() => _applyCard()}
          >
            {t("apply_card")}
          </Button>
        </Stack>
      </Box>

      <MobileDialog
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        onSuccess={_onMobileBindSuccess}
      />
      <KYCDialog open={kycOpen} onClose={() => setKycOpen(false)}/>
      <OpenOrDownloadApp
        open={showAppStoreModal}
        onClose={() => setShowAppStoreModal(false)}
      />
    </Box>
  );
}
